import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { skipWhile, take } from 'rxjs/operators';
import { IGuestCart } from '../../../models/guest.models';
import { ImageUtils } from '../../../utils/image.utils';
import { MarketingFacade } from '../../../facades/marketing.facade';

@Component({
  selector: 'app-guest-cart',
  templateUrl: './guest-cart.component.html',
  styleUrl: './guest-cart.component.scss',
})
export class GuestCartComponent implements OnInit {

  protected readonly ImageUtils = ImageUtils;

  guestCart: IGuestCart;
  guestCartLoading: boolean = true;

  constructor(private marketingFacade: MarketingFacade, private router: Router, private route: ActivatedRoute) {
  }

  /**
   * Initializes the guest cart data.
   */
  ngOnInit(): void {
    this.marketingFacade.selectGuestCart().pipe(
      skipWhile(guestCart => !guestCart),
      take(1),
    ).subscribe(guestCart => {
      this.guestCart = guestCart;
      this.guestCartLoading = false;
    });
  }

  /**
   * Navigates to the guest delivery details page.
   */
  proceedToNextStep(): void {
    this.router.navigate(
      [`checkout/delivery-details/${this.route.snapshot.paramMap.get('guestUserId')}/${this.route.snapshot.paramMap.get('guestCartId')}`],
    );
  }
}
